import { Col, Container, Row } from "reactstrap";
import Description from "./Description";
import { BiTargetLock } from "react-icons/bi";
import { GiKangaroo } from "react-icons/gi";
import { PiShareNetworkFill } from "react-icons/pi";
import { FaLocationDot } from "react-icons/fa6";

const Why = () => {

  const listWhy = [
    { icon:<BiTargetLock className="why-icon" />, title: "Fokus Praktis & Siap Kerja", body: "Belajar bukan sekadar teori — kamu langsung praktek di fasilitas modern mirip tempat kerja nyata (restoran, lab, studio, bengkel, dll) untuk siap kerja setelah lulus!."},
    { icon:<GiKangaroo className="why-icon" />, title: "Diakui Pemerintah Australia", body: "TIWA adalah organisasi resmi yang diawasi pemerintah WA & Australia, jadi sertifikasimu diakui secara nasional dan bisa jadi modal kerja di mana saja."},
    { icon:<PiShareNetworkFill className="why-icon" />, title: "Koneksi Industri & Work Placement", body: "Banyak program termasuk kerja praktik dan jaringan industri yang membantu kamu punya pengalaman kerja nyata saat masih kuliah."},
    { icon:<FaLocationDot className="why-icon" />, title: "Lokasi Strategis + Outdoor Life", body: "Belajar di Perth & wilayah WA yang aman, nyaman, punya cuaca cerah, pantai, dan suasana studi yang santai tapi produktif."},
  ]

  return (
    <section className="section" id="why">
      <Container>
        <Row className="why-wrapper flex-lg-row gap-4">
        <Description />
          <Col>
            <img 
              src="assets/images/img-why.webp" 
              alt="melbourne-polytechnic-sign-and-students-of-melbourne-polytechnic's" 
              className="img-fluid"
            />          
          </Col>
          <Col>
            <h1 className="mb-3"><b>4 Keunggulan Kampus TIWA</b></h1>
            <div className="mb-3 mb-md-5">
              {listWhy.map((item, id) => (
                <div key={id} className="d-flex text-start gap-2">
                  <div>
                    {item.icon}         
                  </div>
                  <div>
                      <span className="fw-bold">{item.title}</span>
                      <p className="fw-normal">{item.body}</p>
                  </div>                
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>      
    </section>
  );
};

export default Why;